export default __webpack_public_path__ + "static/media/cards_flips_6.0ed184af.mp3";